import { render, staticRenderFns } from "./train-auto-select.vue?vue&type=template&id=5fa79bfe&scoped=true"
import script from "./train-auto-select.vue?vue&type=script&lang=js"
export * from "./train-auto-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa79bfe",
  null
  
)

export default component.exports